module.exports = __webpack_public_path__ + "static/media/Stand-Up-Sprint-1-Audio-2.ff4bd9b8.mp3";